 import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

import '../../../node_modules/swiper/swiper.css';
import '../../../node_modules/swiper/modules/effect-fade/effect-fade.min.css';

const init = () => {

    if(document.querySelector('.block-trattamenti__slider') != null){
        const swiper = new Swiper('.block-trattamenti__slider', {
            modules: [Navigation, Pagination, EffectFade],
            speed: 800,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            //direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            pagination: {
                el: '.block-trattamenti__slider-pagination',
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return number < 10 ? '0' + number : number;
                },
                formatFractionTotal: function (number) {
                    return number < 10 ? '0' + number : number;
                }
            },
            navigation: {
                nextEl: '.block-trattamenti__slider-button-next',
                prevEl: '.block-trattamenti__slider-button-prev',
            },
        });

        const swiper_bg = new Swiper('.block-trattamenti__slider-bg', {
            modules: [Navigation, EffectFade],
            speed: 800,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            slidesPerView: 1
        });

        swiper.on('slideNextTransitionStart', function (e) {
            swiper_bg.slideNext();
        });

        swiper.on('slidePrevTransitionStart', function (e) {
            swiper_bg.slidePrev();
        });
    }

    const swiper_valori = new Swiper('.block-valori__slider', {
        modules: [Navigation, Pagination, EffectFade],
        speed: 800,
        //effect: 'fade',
        //direction: 'vertical',
        loop: true,
        slidesPerView: 1,
        pagination: {
            el: '.block-valori__slider-pagination',
            type: 'fraction',
            formatFractionCurrent: function (number) {
                return number < 10 ? '0' + number : number;
            },
            formatFractionTotal: function (number) {
                return number < 10 ? '0' + number : number;
            }
        },
        navigation: {
            nextEl: '.block-valori__slider-button-next',
            prevEl: '.block-valori__slider-button-prev',
        },
    });

    const swiper_textImg = new Swiper('.block-text-img-slider__slider', {
        modules: [Navigation, Pagination, EffectFade],
        speed: 800,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        spaceBetween: 30,
        loop: true,
        slidesPerView: 1,
        pagination: {
            el: '.block-text-img-slider__slider-pagination',
            type: 'fraction',
            formatFractionCurrent: function (number) {
                return number < 10 ? '0' + number : number;
            },
            formatFractionTotal: function (number) {
                return number < 10 ? '0' + number : number;
            }
        },
        navigation: {
            nextEl: '.block-text-img-slider__slider-button-next',
            prevEl: '.block-text-img-slider__slider-button-prev',
        },
    });

    if(document.querySelector('.block-cards-slider__slider')){

        const swiper_cards_elm = document.querySelectorAll('.block-cards-slider__slider');
        const swiper_cards = [];

        swiper_cards_elm.forEach((elm) => {
            
            swiper_cards[elm] = new Swiper(elm, {
                modules: [Navigation, EffectFade],
                speed: 800,
                //effect: 'fade',
                //direction: 'vertical',
                loop: false,
                slidesPerView: 1,
                spaceBetween: 30,
                navigation: {
                    nextEl: elm.querySelector('.block-cards-slider__slider-button-next'),
                    prevEl: elm.querySelector('.block-cards-slider__slider-button-prev'),
                    disabledClass: 'disabled',
                    hiddenClass: 'swiper-button-hidden'
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1024: {
                        slidesPerView: elm.getAttribute('data-cols'),
                        spaceBetween: 30
                    }
                }
            });
        });

        /*
        const swiper_cards = new Swiper('.block-cards-slider__slider', {
            modules: [Navigation, EffectFade],
            speed: 800,
            //effect: 'fade',
            //direction: 'vertical',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '.block-cards-slider__slider-button-next',
                prevEl: '.block-cards-slider__slider-button-prev',
                disabledClass: 'disabled',
                hiddenClass: 'swiper-button-hidden'
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: document.querySelector('.block-cards-slider__slider').getAttribute('data-cols'),
                    spaceBetween: 30
                }
            }
        });
        */
    }

    if(document.querySelector('.block-gallery__slider')){

        const gallery_slider = new Swiper('.block-gallery__slider', {
            modules: [Navigation],
            speed: 800,
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: '.block-gallery__slider-button-next',
                prevEl: '.block-gallery__slider-button-prev',
                disabledClass: 'disabled',
                hiddenClass: 'swiper-button-hidden'
            },
        });
    }

};

export default { init };